module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAsElEQVQ4T52Siw3CMAwFXycBJgEmgU5CmYQyCbAJm4AuekYmCpWIJauprfN/UKcMnZxqcC3pJukp6eGgK3/5nyNRBneGNgZzMUdJBwebcGTwJakFRQCquUgaCRwgEbc2LrVNNtqYA8Rwty6BtEPJY4CUcDVIEJxZ8GGPcvcZ/Jraj7RkRKd/e6SykiBPlf1hLONuCAMELEy9x+i1hgP6rKt1OSf3wZQZBsr7nA+j+1bfJfEoDw8b6zgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/minus-zoom.png
// module id = B0bK
// module chunks = 2